import { useCallback, useEffect, useMemo, useState } from "react";
import { getLandedCostSkuExclusionHistory } from "../../API/landedCostSkuExclusionHistoryApi";

const extractRows = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }
  if (payload && typeof payload === "object") {
    const candidates = ["queryResults", "elements", "data", "rows", "content"];
    for (const key of candidates) {
      if (Array.isArray(payload[key])) {
        return payload[key];
      }
    }
  }
  return [];
};

export const useLandedCostSkuExclusionHistory = () => {
  const [rawRows, setRawRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchHistory = useCallback(async () => {
    setLoading(true);
    try {
      const history = await getLandedCostSkuExclusionHistory();
      setRawRows(history || []);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  const rows = useMemo(() => extractRows(rawRows), [rawRows]);

  return { rows, loading, fetchHistory };
};

export default useLandedCostSkuExclusionHistory;
